<div class="position-relative" #root>
    <!-- Trigger -->
    <button
        type="button"
        class="form-control custom-trigger d-flex align-items-center justify-content-between px-3 py-2 text-start"
        (click)="toggle()"
        [attr.aria-expanded]="open"
        aria-haspopup="listbox">
        <div class="d-flex align-items-center text-truncate" style="gap: 0.5rem; min-width: 0">
            <i [ngClass]="selected.length ? selectedIcon : defaultIcon" class="mr-2" aria-hidden="true"></i>

            <ng-container *ngIf="selectedNames.length; else placeholderTpl">
                <ng-container *ngFor="let l of previewNames; let i = index">
                    <span class="selected-badge small">{{ l }}</span>
                </ng-container>
                <span *ngIf="extraCount > 0" class="text-muted small ml-1">+{{ extraCount }}</span>
            </ng-container>

            <ng-template #placeholderTpl>
                <span class="select-placeholder">{{ placeholder }}</span>
            </ng-template>
        </div>

        <div class="right-meta d-flex align-items-center text-muted small" style="min-width: 0">
            <span *ngIf="selected.length" class="pr-2">{{ selected.length }} selected</span>
        </div>
    </button>

    <!-- Dropdown -->
    <div
        class="dropdown-menu p-3 mt-1"
        [class.show]="open"
        style="position: absolute; left: 0; right: 0; z-index: 2000; width: auto">
        <!-- Search -->
        <div class="mb-2">
            <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-white border-right-0">
                        <i class="bi bi-search"></i>
                    </span>
                </div>

                <input class="form-control border-left-0" placeholder="Search..." [formControl]="searchControl" />

                <div *ngIf="searchControl.value" class="input-group-append">
                    <button
                        type="button"
                        class="btn btn-light border-left-0"
                        (click)="searchControl.setValue('')"
                        title="Clear search">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- actions -->
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="btn-group btn-group-sm" role="group" aria-label="quick actions">
                <button
                    type="button"
                    class="btn btn-outline-secondary d-flex align-items-center px-2"
                    (click)="selectAll()">
                    <i class="bi bi-check2-all mr-1"></i>
                    <span class="d-none d-md-inline">Select all</span>
                </button>
                <button
                    type="button"
                    class="btn btn-outline-secondary d-flex align-items-center px-2"
                    (click)="clear()">
                    <i class="bi bi-x-circle mr-1"></i>
                    <span class="d-none d-md-inline">Clear</span>
                </button>
            </div>

            <div class="small text-muted">{{ filteredOptions.length }} items</div>
        </div>

        <!-- options -->
        <div class="multiselect-list list-group" style="max-height: 260px; overflow: auto">
            <label
                *ngFor="let o of filteredOptions; trackBy: trackById"
                class="list-group-item d-flex align-items-center justify-content-between p-2 mb-1"
                [class.selected-row]="isSelected(o)"
                [class.disabled]="o.disabled"
                style="cursor: pointer"
                (click)="onRowClick(o, $event)">
                <div class="d-flex align-items-center" style="gap: 0.75rem; min-width: 0">
                    <div
                        class="form-check m-0 d-flex align-items-center justify-content-center"
                        style="min-width: 1.6rem">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [disabled]="o.disabled"
                            [checked]="isSelected(o)"
                            (change)="toggleOption(o, $event.target.checked)"
                            (click)="$event.stopPropagation()"
                            [attr.aria-label]="'Select ' + o.name" />
                    </div>

                    <div class="text-truncate" style="min-width: 0">
                        <div class="small mb-0 text-truncate">{{ o.name }}</div>
                        <div *ngIf="o.disabled" class="small text-muted">disabled</div>
                    </div>
                </div>

                <div class="ml-2 d-flex align-items-center" style="min-width: 1.2rem">
                    <i *ngIf="isSelected(o)" class="bi bi-check-lg" aria-hidden="true"></i>
                </div>
            </label>

            <div *ngIf="!filteredOptions.length" class="text-center text-muted small py-3">No items</div>
        </div>

        <!-- footer -->
        <div class="mt-3 d-flex justify-content-end align-items-center">
            <button type="button" class="btn btn-sm btn-primary mr-2" (click)="apply()">Apply</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="close()">Close</button>
        </div>
    </div>
</div>
